<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit driver: {{ user.id }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="update">Update</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field v-model="form.firstname" label="Firstname" required></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field v-model="form.lastname" label="Lastname" required></v-text-field>
              </v-flex>
              <v-flex xs12 md4 class="content-align-right">
                  <m-reset-pw-btn :user="user"></m-reset-pw-btn>
              </v-flex>


              <v-flex xs10>
                <g-input
                  :required="true"
                  id="address_edit"
                  ref="address"
                  @change="setAddress"
                  @placechanged="setPlace"
                  :label="'Address'"
                  :clearable="true"
                  :delete="true"
                  :rules="itemRules"
                  :error="adress_notValid"
                ></g-input>
                <span v-if="adress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs2>
                <v-text-field v-model="form.postbox" label="Postbox"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.birthday" label="birthday" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.mobile" label="mobile" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.tel" label="tel" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.email" label="Email" required></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field v-model="form.bank_account" label="Bank account" required></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field v-model="form.car" label="Car"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4></v-flex>
               <v-flex xs12 sm2 >
                <v-checkbox class="mt-3"
                  color="primary"
                  label="Active"
                  v-model="active"
                  @change="form.active = active"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-select v-model="form.refreshTime"
                  label="Refresh Time"
                  required
                  :items="[15, 30, 60, 120]"
                ></v-select>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field v-model="form.zones" label="Zones"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import DriverMixin from '@/mixins/driver-form';

  export default {
    mixins: [DriverMixin],
    methods: {
      init (v) {
        if (v) {
          console.log('Edit: do init:', this.user);
          this.prefill(this.user);
        }
      }
    }
  }
</script>

